import React from 'react';
import styles from './form.module.scss';

type FormFieldRowProps = {
    children: React.ReactNode;
};

export const FormFieldRow = ({ children }: FormFieldRowProps) => {
    const childArray = React.Children.toArray(children);

    return (
        <div className={styles.fieldRow}>
            {childArray.map((child, index) => (
                <div key={index} className={styles.fieldCol}>
                    {child}
                </div>
            ))}
        </div>
    );
};
